/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "merchant_catalog": {
                "nested": {
                  "resources": {
                    "nested": {
                      "CatalogItemProductType": {
                        "values": {
                          "REGULAR": 0,
                          "GIFT_CARD": 1,
                          "APPOINTMENTS_SERVICE": 2,
                          "CLASS_TICKET": 5,
                          "FOOD_AND_BEV": 6,
                          "EVENT": 7,
                          "DIGITAL": 8,
                          "DONATION": 9,
                          "MEMBERSHIP": 10,
                          "CREDIT_PACKAGE": 11,
                          "COMBO": 13,
                          "LEGACY_SQUARE_ONLINE_SERVICE": 14,
                          "LEGACY_SQUARE_ONLINE_MEMBERSHIP": 15,
                          "APPOINTMENTS_MEMBERSHIP": 16
                        }
                      },
                      "CatalogCategoryType": {
                        "values": {
                          "CATALOG_CATEGORY_TYPE_DO_NOT_USE": 0,
                          "REGULAR_CATEGORY": 1,
                          "MENU_CATEGORY": 2,
                          "KITCHEN_CATEGORY": 3
                        }
                      },
                      "InventoryAlertType": {
                        "values": {
                          "INVENTORY_ALERT_TYPE_DO_NOT_USE": 0,
                          "NONE": 1,
                          "LOW_QUANTITY": 2
                        }
                      },
                      "Subscriptions": {
                        "fields": {},
                        "nested": {
                          "Tenant": {
                            "values": {
                              "SUBSCRIPTION_TENANT_DO_NOT_USE": 0,
                              "BUYER": 1,
                              "APPOINTMENTS_MEMBERSHIP": 2
                            }
                          }
                        }
                      },
                      "CatalogPricingType": {
                        "values": {
                          "FIXED_PRICING": 0,
                          "VARIABLE_PRICING": 1
                        }
                      },
                      "TaxCalculationPhase": {
                        "values": {
                          "TAX_SUBTOTAL_PHASE": 2,
                          "TAX_TOTAL_PHASE": 3
                        }
                      },
                      "TaxInclusionType": {
                        "values": {
                          "ADDITIVE": 0,
                          "INCLUSIVE": 1
                        }
                      },
                      "CatalogDiscountType": {
                        "values": {
                          "FIXED_PERCENTAGE": 0,
                          "FIXED_AMOUNT": 1,
                          "VARIABLE_PERCENTAGE": 2,
                          "VARIABLE_AMOUNT": 3
                        }
                      },
                      "CatalogDiscountApplicationMethod": {
                        "values": {
                          "MANUALLY_APPLIED": 1,
                          "COMP": 2
                        }
                      },
                      "CatalogDiscountModifyTaxBasis": {
                        "values": {
                          "MODIFY_TAX_BASIS": 0,
                          "DO_NOT_MODIFY_TAX_BASIS": 1
                        }
                      },
                      "CatalogSalePriceType": {
                        "values": {
                          "SALE_PRICE_TYPE_DO_NOT_USE": 0,
                          "SALE_PRICE_TYPE_FIXED_AMOUNT": 1,
                          "SALE_PRICE_TYPE_FIXED_PERCENTAGE": 2
                        }
                      },
                      "CatalogModifierListSelectionType": {
                        "values": {
                          "SINGLE": 0,
                          "MULTIPLE": 1
                        }
                      },
                      "AggregationStrategy": {
                        "values": {
                          "UNKNOWN": 0,
                          "STACKABLE": 2,
                          "EXCLUSIVE": 3
                        }
                      },
                      "CatalogObjectType": {
                        "values": {
                          "CATALOG_OBJECT_TYPE_DO_NOT_USE": 0,
                          "ITEM": 1,
                          "IMAGE": 2,
                          "PAGE_TILE": 3,
                          "CATEGORY": 4,
                          "ITEM_VARIATION": 5,
                          "TAX": 6,
                          "PLACEHOLDER": 7,
                          "DISCOUNT": 8,
                          "MODIFIER_LIST": 10,
                          "MODIFIER": 12,
                          "DINING_OPTION": 18,
                          "TAX_EXEMPTION": 19,
                          "CONFIGURATION": 20,
                          "TICKET_GROUP": 22,
                          "TICKET_TEMPLATE": 23,
                          "PAGE": 21,
                          "MENU": 26,
                          "TAG": 27,
                          "FLOOR_PLAN": 28,
                          "FLOOR_PLAN_TILE": 29,
                          "VOID_REASON": 24,
                          "FAVORITES_LIST_POSITION": 30,
                          "MENU_GROUP": 31,
                          "ITEM_VARIATION_VENDOR_INFO": 25,
                          "SERVICE_CHARGE": 32,
                          "PRICING_RULE": 33,
                          "PRODUCT_SET": 34,
                          "TIME_PERIOD": 35,
                          "MEASUREMENT_UNIT": 37,
                          "SUBSCRIPTION_PLAN_VARIATION": 38,
                          "ITEM_OPTION": 39,
                          "ITEM_OPTION_VAL": 40,
                          "CUSTOM_ATTRIBUTE_DEFINITION": 41,
                          "QUICK_AMOUNTS_SETTINGS": 45,
                          "COMPONENT": 47,
                          "COMPOSITION": 48,
                          "RESOURCE": 49,
                          "CHECKOUT_LINK": 52,
                          "ADDRESS": 57,
                          "SETTINGS": 58,
                          "SUBSCRIPTION_PLAN": 59,
                          "AVAILABILITY_PERIOD": 61,
                          "CREDIT_REDEMPTION_POLICY": 62,
                          "AGE_RESTRICTION": 63,
                          "SALE_PRICE": 65,
                          "TRANSLATIONS": 70
                        }
                      },
                      "ExcludeStrategy": {
                        "values": {
                          "EXCLUDE_STRATEGY_DO_NOT_USE": 0,
                          "LEAST_EXPENSIVE": 1,
                          "MOST_EXPENSIVE": 2
                        }
                      },
                      "CatalogPricingRuleApplicationMode": {
                        "values": {
                          "PRICING_RULE_APPLICATION_MODE_DO_NOT_USE": 0,
                          "AUTOMATIC": 1,
                          "ATTACHED": 2,
                          "MANUAL_APPLICATION": 3
                        }
                      },
                      "DiscountTargetScope": {
                        "values": {
                          "DISCOUNT_TARGET_SCOPE_DO_NOT_USE": 0,
                          "LINE_ITEM": 1,
                          "WHOLE_PURCHASE": 2
                        }
                      },
                      "ServiceChargeTargetScope": {
                        "values": {
                          "SURCHARGE_TARGET_SCOPE_DO_NOT_USE": 0,
                          "SURCHARGE_TARGET_SCOPE_LINE_ITEM": 1,
                          "SURCHARGE_TARGET_SCOPE_WHOLE_PURCHASE": 2
                        }
                      },
                      "CatalogQuickAmountType": {
                        "values": {
                          "QUICK_AMOUNT_TYPE_DO_NOT_USE": 0,
                          "QUICK_AMOUNT_TYPE_MANUAL": 1,
                          "QUICK_AMOUNT_TYPE_AUTO": 2
                        }
                      },
                      "CatalogQuickAmountsSettingsOption": {
                        "values": {
                          "QUICK_AMOUNTS_SETTINGS_OPTION_DO_NOT_USE": 0,
                          "DISABLED": 1,
                          "MANUAL": 2,
                          "AUTO": 3
                        }
                      },
                      "EcomVisibility": {
                        "values": {
                          "ECOM_VISIBILITY_DO_NOT_USE": 0,
                          "UNINDEXED": 1,
                          "UNAVAILABLE": 2,
                          "HIDDEN": 3,
                          "VISIBLE": 4
                        }
                      },
                      "ArchivedState": {
                        "values": {
                          "ARCHIVED_STATE_DO_NOT_USE": 0,
                          "ARCHIVED_STATE_NOT_ARCHIVED": 1,
                          "ARCHIVED_STATE_ARCHIVED": 2,
                          "ARCHIVED_STATE_ALL": 3
                        }
                      },
                      "CatalogServiceChargeType": {
                        "values": {
                          "SERVICE_CHARGE_TYPE_DO_NOT_USE": 0,
                          "AUTO_GRATUITY": 1,
                          "CUSTOM": 2,
                          "CARD_SURCHARGE": 3
                        }
                      },
                      "CatalogServiceChargeCalculationPhase": {
                        "values": {
                          "SURCHARGE_PHASE": 6,
                          "SURCHARGE_TOTAL_PHASE": 7,
                          "SURCHARGE_APPORTIONED_PHASE": 8,
                          "CARD_SURCHARGE_PHASE": 10
                        }
                      },
                      "CatalogServiceChargeAutoEnableType": {
                        "values": {
                          "AUTO_ENABLE_TYPE_DO_NOT_USE": 0,
                          "MINIMUM_SEAT_COUNT": 1,
                          "ALWAYS": 2
                        }
                      },
                      "CatalogServiceChargeCalculationType": {
                        "values": {
                          "SURCHARGE_FIXED": 0,
                          "SURCHARGE_VARIABLE_PERCENTAGE": 1,
                          "SURCHARGE_VARIABLE_AMOUNT": 2
                        }
                      },
                      "CatalogServiceChargeTreatmentType": {
                        "values": {
                          "SURCHARGE_TREATMENT_DO_NOT_USE": 0,
                          "SURCHARGE_TREATMENT_LINE_ITEM": 1,
                          "SURCHARGE_TREATMENT_APPORTIONED": 2
                        }
                      },
                      "SubscriptionCadence": {
                        "values": {
                          "SUBSCRIPTION_CADENCE_DO_NOT_USE": 0,
                          "DAILY": 1,
                          "WEEKLY": 2,
                          "EVERY_TWO_WEEKS": 3,
                          "THIRTY_DAYS": 4,
                          "SIXTY_DAYS": 5,
                          "NINETY_DAYS": 6,
                          "MONTHLY": 7,
                          "EVERY_TWO_MONTHS": 8,
                          "QUARTERLY": 9,
                          "EVERY_FOUR_MONTHS": 10,
                          "EVERY_SIX_MONTHS": 11,
                          "ANNUAL": 12,
                          "EVERY_TWO_YEARS": 13
                        }
                      },
                      "SubscriptionPricingType": {
                        "values": {
                          "SUBSCRIPTION_PRICING_DO_NOT_USE": 0,
                          "STATIC": 1,
                          "RELATIVE": 2
                        }
                      },
                      "CheckoutLinkType": {
                        "values": {
                          "CHECKOUT_LINK_TYPE_DO_NOT_USE": 0,
                          "PAYMENT_LINK": 1,
                          "DONATION_LINK": 2,
                          "ITEM_LINK": 3,
                          "CLASS_LINK": 4,
                          "SERVICE_LINK": 5
                        }
                      },
                      "InlineTypes": {
                        "values": {
                          "INLINE_NONE": 0,
                          "INLINE_VARIATIONS": 1,
                          "INLINE_ALL": 2,
                          "INLINE_ITEM_TAX_IDS": 3,
                          "INLINE_ITEM_LEGACY_TAX_IDS": 4,
                          "INLINE_ITEM_MODIFIER_LIST_INFO": 5,
                          "INLINE_SURCHARGE_LEGACY_TAX_IDS": 6,
                          "INLINE_EVENTS": 7,
                          "INLINE_QUICK_AMOUNTS": 8,
                          "INLINE_SUBSCRIPTION_PHASES": 9,
                          "INLINE_CHECKOUT_LINK_LINE_ITEMS": 10,
                          "INLINE_CHECKOUT_LINK_CUSTOM_FIELDS": 11,
                          "INLINE_CUSTOM_ATTRIBUTE_SELECTIONS": 12,
                          "INLINE_COGS_IDS": 13,
                          "INLINE_SUBSCRIPTION_PLAN_IDS": 14,
                          "INLINE_SUBSCRIPTION_PLAN_VARIATIONS": 15,
                          "INLINE_ITEM_VARIATION_VENDOR_INFOS": 16,
                          "INLINE_CREDIT_REDEMPTION_POLICIES": 17,
                          "INLINE_PRICING_OBJECTS_FOR_ABACUS": 18
                        }
                      },
                      "EventLocationType": {
                        "values": {
                          "EVENT_LOCATION_TYPE_DO_NOT_USE": 0,
                          "IN_PERSON": 1,
                          "ONLINE": 2
                        }
                      },
                      "NullableField": {
                        "values": {
                          "NULLABLE_FIELD_DO_NOT_USE": 0,
                          "VENDOR_TOKEN": 1
                        }
                      },
                      "StockLevel": {
                        "values": {
                          "STOCK_LEVEL_DO_NOT_USE": 0,
                          "OUT": 1,
                          "LOW": 2
                        }
                      },
                      "CatalogServiceChargeEcomFulfillmentType": {
                        "values": {
                          "ECOM_FULFILLMENT_TYPE_DO_NOT_USE": 0,
                          "ECOM_FULFILLMENT_TYPE_PICKUP": 1,
                          "ECOM_FULFILLMENT_TYPE_DELIVERY": 2,
                          "ECOM_FULFILLMENT_TYPE_DINE_IN": 3,
                          "ECOM_FULFILLMENT_TYPE_SHIPPING": 4
                        }
                      },
                      "CatalogPricingSource": {
                        "values": {
                          "PRICING_SOURCE_DO_NOT_USE": 0,
                          "SQUARE_ONLINE": 1,
                          "GIFT_CARDS": 2
                        }
                      },
                      "PricingRulePaymentType": {
                        "values": {
                          "PAYMENT_TYPE_DO_NOT_USE": 0,
                          "CARD": 1,
                          "ONLINE_CARD": 2
                        }
                      },
                      "CatalogProductName": {
                        "values": {
                          "PRODUCT_NAME_UNKNOWN": 0,
                          "PRODUCT_NAME_RESTAURANTS": 1,
                          "PRODUCT_NAME_RETAIL": 2,
                          "PRODUCT_NAME_STANDARD": 3
                        }
                      },
                      "CatalogPlaceholderType": {
                        "values": {
                          "PLACEHOLDER_TYPE_UNKNOWN": 0,
                          "PLACEHOLDER_TYPE_DISCOUNTS_CATEGORY": 1,
                          "PLACEHOLDER_TYPE_REWARDS_FINDER": 2,
                          "PLACEHOLDER_TYPE_ALL_ITEMS": 3,
                          "PLACEHOLDER_TYPE_COUPONS_FINDER": 4,
                          "PLACEHOLDER_TYPE_GIFT_CARDS_CATEGORY": 5,
                          "PLACEHOLDER_TYPE_CUSTOM_AMOUNT": 6,
                          "PLACEHOLDER_TYPE_CALCULATOR": 7,
                          "PLACEHOLDER_TYPE_QUANTITY_2": 8,
                          "PLACEHOLDER_TYPE_QUANTITY_3": 9,
                          "PLACEHOLDER_TYPE_QUANTITY_4": 10,
                          "PLACEHOLDER_TYPE_QUANTITY_5": 11,
                          "PLACEHOLDER_TYPE_QUANTITY_6": 12,
                          "PLACEHOLDER_TYPE_QUANTITY_7": 13,
                          "PLACEHOLDER_TYPE_QUANTITY_8": 14,
                          "PLACEHOLDER_TYPE_QUANTITY_9": 15,
                          "PLACEHOLDER_TYPE_CUSTOM_QUANTITY": 16,
                          "PLACEHOLDER_TYPE_CLOCK_IN_OUT": 17,
                          "PLACEHOLDER_TYPE_ISSUE_REFUND": 18,
                          "PLACEHOLDER_TYPE_ADJUST_TIP": 19,
                          "PLACEHOLDER_TYPE_COMP_VOID": 20,
                          "PLACEHOLDER_TYPE_ADD_CUSTOMER": 21,
                          "PLACEHOLDER_TYPE_EDIT_TICKET_NAME_AND_NOTES": 22,
                          "PLACEHOLDER_TYPE_VOID_TICKET": 23,
                          "PLACEHOLDER_TYPE_COMP_TICKET": 24,
                          "PLACEHOLDER_TYPE_SPLIT_TICKET": 25,
                          "PLACEHOLDER_TYPE_MOVE_TICKET": 26,
                          "PLACEHOLDER_TYPE_ASSIGN_TICKET": 27,
                          "PLACEHOLDER_TYPE_EDIT_TICKET_SEATS": 28,
                          "PLACEHOLDER_TYPE_EDIT_TICKET_ALLERGY": 29,
                          "PLACEHOLDER_TYPE_CUSTOM_DISCOUNT": 30,
                          "PLACEHOLDER_TYPE_DINING_OPTION_CATEGORY": 31,
                          "PLACEHOLDER_TYPE_ORDER_HISTORY": 32,
                          "PLACEHOLDER_TYPE_CUSTOM_GIFT_CARD": 33,
                          "PLACEHOLDER_TYPE_OPEN_ALL_DRAWERS": 34,
                          "PLACEHOLDER_TYPE_PAY_IN_OUT": 35,
                          "PLACEHOLDER_TYPE_LINE": 36,
                          "PLACEHOLDER_TYPE_SHAPE": 37,
                          "PLACEHOLDER_TYPE_TEXT_LABEL": 38,
                          "PLACEHOLDER_TYPE_AUTO_GRATUITY": 39,
                          "PLACEHOLDER_TYPE_ALL_SERVICES": 40,
                          "PLACEHOLDER_TYPE_ALL_ITEMS_AND_SERVICES": 41,
                          "PLACEHOLDER_TYPE_SERVICE_CHARGES": 42,
                          "PLACEHOLDER_TYPE_ALL_CUSTOMERS": 43,
                          "PLACEHOLDER_TYPE_ALL_CARTS": 44,
                          "PLACEHOLDER_TYPE_CREATE_ITEM": 45,
                          "PLACEHOLDER_TYPE_EXCHANGES": 46,
                          "PLACEHOLDER_TYPE_NOTIFY_WHEN_READY": 48,
                          "PLACEHOLDER_TYPE_ALL_CREDIT_PACKAGES": 49,
                          "PLACEHOLDER_TYPE_CLEAR_ALL_CART_ITEMS": 50,
                          "PLACEHOLDER_TYPE_UNAVAILABLE_ON_POS": 51,
                          "PLACEHOLDER_TYPE_COUNT": 52
                        }
                      },
                      "CatalogPageLayout": {
                        "values": {
                          "PAGE_LAYOUT_UNKNOWN": 0,
                          "PAGE_LAYOUT_FLEXIBLE": 1,
                          "PAGE_LAYOUT_IMAGE_TILES_5X5": 2,
                          "PAGE_LAYOUT_TEXT_TILES_3X9": 3,
                          "PAGE_LAYOUT_IMAGE_TEXT_TILES_8X8": 4,
                          "PAGE_LAYOUT_IMAGE_TEXT_TILES_12X11": 5,
                          "PAGE_LAYOUT_IMAGE_TEXT_TILES_12X8": 6,
                          "PAGE_LAYOUT_IMAGE_TEXT_TILES_16X11": 7,
                          "PAGE_LAYOUT_IMAGE_TILES_2X10": 8,
                          "PAGE_LAYOUT_IMAGE_TEXT_TILES_10X10": 9,
                          "PAGE_LAYOUT_IMAGE_TEXT_TILES_2XINFINITE": 10
                        }
                      },
                      "CatalogDeviceFormFactor": {
                        "values": {
                          "DEVICE_FORM_FACTOR_DO_NOT_USE": 0,
                          "DEVICE_FORM_FACTOR_TABLET": 1,
                          "DEVICE_FORM_FACTOR_MOBILE": 2,
                          "DEVICE_FORM_FACTOR_UNIVERSAL": 3
                        }
                      },
                      "CatalogTagType": {
                        "values": {
                          "TAG_TYPE_DEFAULT": 0,
                          "TAG_TYPE_MENU_GROUP": 1
                        }
                      },
                      "CatalogItemVariationWeightUnit": {
                        "values": {
                          "INVALID_WEIGHT": 0,
                          "IMPERIAL_POUND": 1,
                          "METRIC_KILOGRAM": 2
                        }
                      },
                      "CatalogProductSetLineItemType": {
                        "values": {
                          "PRODUCT_SET_LINE_ITEM_TYPE_DO_NOT_USE": 0,
                          "PRODUCT_SET_LINE_ITEM_TYPE_GIFT_CARD": 1
                        }
                      },
                      "CompositionType": {
                        "values": {
                          "INVALID_COMPOSITION_TYPE": 0,
                          "BUNDLE": 1,
                          "STOCK_CONVERSION": 2
                        }
                      },
                      "CatalogVoidReasonAppointmentsType": {
                        "values": {
                          "APPTS_TYPE_NONE": 0,
                          "APPTS_TYPE_CANCEL": 1,
                          "APPTS_TYPE_NO_SHOW": 2
                        }
                      },
                      "CatalogTicketGroupNamingMethod": {
                        "values": {
                          "TICKET_GROUP_DO_NOT_USE": 0,
                          "TICKET_GROUP_AUTOMATIC_NUMBERING": 1,
                          "TICKET_GROUP_MANUAL_NUMBERING": 2
                        }
                      },
                      "CatalogTicketGroupPrefixTableNames": {
                        "values": {
                          "TICKET_GROUP_PREFIX_TABLE_NAMES_DO_NOT_USE": 0,
                          "TICKET_GROUP_PREFIX_TABLE_NAMES_NONE": 1,
                          "TICKET_GROUP_PREFIX_TABLE_NAMES_SECTION": 2
                        }
                      },
                      "CatalogFloorPlanTileShape": {
                        "values": {
                          "FLOOR_PLAN_TILE_SHAPE_DO_NOT_USE": 0,
                          "FLOOR_PLAN_TILE_SHAPE_UNKNOWN": 1,
                          "FLOOR_PLAN_TILE_SHAPE_RECTANGULAR": 2,
                          "FLOOR_PLAN_TILE_SHAPE_ROUNDED_RECTANGLE": 3
                        }
                      },
                      "CatalogModifierListModifierType": {
                        "values": {
                          "LIST": 0,
                          "TEXT": 1
                        }
                      },
                      "ServiceCostType": {
                        "values": {
                          "FLAT_PRICING": 0,
                          "PERCENT_PRICING": 1
                        }
                      },
                      "SellableValue": {
                        "values": {
                          "SELLABLE_VALUE_DO_NOT_USE": 0,
                          "SELLABLE": 1,
                          "NON_SELLABLE": 2
                        }
                      },
                      "StockableValue": {
                        "values": {
                          "STOCKABLE_VALUE_DO_NOT_USE": 0,
                          "STOCKABLE": 1,
                          "NON_STOCKABLE": 2
                        }
                      },
                      "CatalogModifierToggleOverrideType": {
                        "values": {
                          "NO": 0,
                          "YES": 1,
                          "NOT_SET": 2
                        }
                      },
                      "TaxExemptionActionType": {
                        "values": {
                          "TAX_EXEMPTION_APPLICATION_VALUE_DO_NOT_USE": 0,
                          "EXEMPTION": 1,
                          "ADJUSTMENT": 2
                        }
                      },
                      "CatalogProgramType": {
                        "values": {
                          "PROGRAM_DO_NOT_USE": 0,
                          "SNAP": 1,
                          "EBT_CASH": 2
                        }
                      },
                      "CatalogProgramEligibilityStatus": {
                        "values": {
                          "ELIGIBILITY_DO_NOT_USE": 0,
                          "INELIGIBLE": 1,
                          "ELIGIBLE": 2
                        }
                      },
                      "IgnoreItemDefaultsField": {
                        "values": {
                          "IGNORE_ITEM_DEFAULTS_DO_NOT_USE": 0,
                          "CHANNELS": 1
                        }
                      },
                      "IncludeType": {
                        "values": {
                          "INCLUDE_OPTION_DO_NOT_USE": 0,
                          "INCLUDE_NESTED_MODIFIERS": 1,
                          "INCLUDE_DRAFT_REPRESENTATIONS": 2
                        }
                      },
                      "CatalogModifierColor": {
                        "values": {
                          "CATALOG_MODIFIER_COLOR_DO_NOT_USE": 0,
                          "BURGUNDY": 1,
                          "TAUPE": 2,
                          "BROWN": 3,
                          "FOREST": 4,
                          "TEAL": 5,
                          "SKY": 6,
                          "ORANGE": 7,
                          "YELLOW": 8,
                          "GREEN": 9,
                          "BLUE": 10,
                          "PURPLE": 11,
                          "PINK": 12
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogItemProductType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogCategoryType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.InventoryAlertType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.Subscriptions && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.Subscriptions?.nested?.Tenant && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogPricingType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.TaxCalculationPhase && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.TaxInclusionType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogDiscountType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogDiscountApplicationMethod && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogDiscountModifyTaxBasis && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogSalePriceType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogModifierListSelectionType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.AggregationStrategy && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogObjectType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.ExcludeStrategy && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogPricingRuleApplicationMode && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.DiscountTargetScope && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.ServiceChargeTargetScope && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogQuickAmountType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogQuickAmountsSettingsOption && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.EcomVisibility && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.ArchivedState && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogServiceChargeType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogServiceChargeCalculationPhase && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogServiceChargeAutoEnableType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogServiceChargeCalculationType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogServiceChargeTreatmentType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.SubscriptionCadence && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.SubscriptionPricingType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CheckoutLinkType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.InlineTypes && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.EventLocationType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.NullableField && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.StockLevel && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogServiceChargeEcomFulfillmentType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogPricingSource && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.PricingRulePaymentType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogProductName && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogPlaceholderType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogPageLayout && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogDeviceFormFactor && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogTagType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogItemVariationWeightUnit && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogProductSetLineItemType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CompositionType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogVoidReasonAppointmentsType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogTicketGroupNamingMethod && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogTicketGroupPrefixTableNames && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogFloorPlanTileShape && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogModifierListModifierType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.ServiceCostType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.SellableValue && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.StockableValue && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogModifierToggleOverrideType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.TaxExemptionActionType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogProgramType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogProgramEligibilityStatus && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.IgnoreItemDefaultsField && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.IncludeType && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.resources?.nested?.CatalogModifierColor) {
  $root.addJSON(jsonData);
}

/**
 * @desc The type of a CatalogItem. Connect V2 only allows the creation of `REGULAR` or `APPOINTMENTS_SERVICE` items.
 *
 * SOURCE CatalogItemProductType @ squareup/connect/v2/catalog/resources/enums.proto at 17:1
 */
export const CatalogItemProductType = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.CatalogItemProductType').values;
/**
 * @desc Indicates the type of a category.
 *
 * SOURCE CatalogCategoryType @ squareup/connect/v2/catalog/resources/enums.proto at 69:1
 */
export const CatalogCategoryType = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.CatalogCategoryType').values;
/**
 * @desc Indicates whether Square should alert the merchant when the inventory quantity of a CatalogItemVariation is low.
 *
 * SOURCE InventoryAlertType @ squareup/connect/v2/catalog/resources/enums.proto at 86:1
 */
export const InventoryAlertType = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.InventoryAlertType').values;
/**
 * --
 * @desc Subscriptions Tenant denotes the owner of the subscription plan
 * Using it in a nested way to avoid conflicts with other enums
 * --
 *
 * SOURCE Subscriptions @ squareup/connect/v2/catalog/resources/enums.proto at 103:1
 */
export const Subscriptions = $root.lookupType('squareup.connect.v2.merchant_catalog.resources.Subscriptions');
fixType(Subscriptions);
Builder.createAndAttachToType(Subscriptions);
/**
 * SOURCE Tenant @ squareup/connect/v2/catalog/resources/enums.proto at 105:3
 */
Subscriptions.Tenant = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.Subscriptions.Tenant').values;
/**
 * @desc Indicates whether the price of a CatalogItemVariation should be entered manually at the time of sale.
 *
 * SOURCE CatalogPricingType @ squareup/connect/v2/catalog/resources/enums.proto at 124:1
 */
export const CatalogPricingType = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.CatalogPricingType').values;
/**
 * Tax specific Items V1 calculation phases. The tag numbers MUST match the ones
 * defined in squareup/items/items.proto for Items V1.
 * @desc When to calculate the taxes due on a cart.
 *
 * SOURCE TaxCalculationPhase @ squareup/connect/v2/catalog/resources/enums.proto at 138:1
 */
export const TaxCalculationPhase = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.TaxCalculationPhase').values;
/**
 * @desc Whether to the tax amount should be additional to or included in the CatalogItem price.
 *
 * SOURCE TaxInclusionType @ squareup/connect/v2/catalog/resources/enums.proto at 149:1
 */
export const TaxInclusionType = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.TaxInclusionType').values;
/**
 * @desc How to apply a CatalogDiscount to a CatalogItem.
 *
 * SOURCE CatalogDiscountType @ squareup/connect/v2/catalog/resources/enums.proto at 169:1
 */
export const CatalogDiscountType = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.CatalogDiscountType').values;
/**
 * SOURCE CatalogDiscountApplicationMethod @ squareup/connect/v2/catalog/resources/enums.proto at 185:1
 */
export const CatalogDiscountApplicationMethod = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.CatalogDiscountApplicationMethod').values;
/**
 * SOURCE CatalogDiscountModifyTaxBasis @ squareup/connect/v2/catalog/resources/enums.proto at 195:1
 */
export const CatalogDiscountModifyTaxBasis = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.CatalogDiscountModifyTaxBasis').values;
/**
 * --
 * @desc How to apply a CatalogSalePrice to a CatalogItemVariation. the two allowed types are:
 *
 * - SALE_PRICE_TYPE_FIXED_AMOUNT: This type specifies that the item has a sale price that's a predetermined
 * flat amount replacing its original price.
 *
 * - SALE_PRICE_TYPE_FIXED_PERCENTAGE: This type indicates that the item's sale price is a specific percentage
 * off its original price. For instance, a 20% sale price would mean that the item is being
 * sold at 80% of its original price.
 * --
 *
 * SOURCE CatalogSalePriceType @ squareup/connect/v2/catalog/resources/enums.proto at 216:1
 */
export const CatalogSalePriceType = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.CatalogSalePriceType').values;
/**
 * @desc Indicates whether a CatalogModifierList supports multiple selections.
 *
 * SOURCE CatalogModifierListSelectionType @ squareup/connect/v2/catalog/resources/enums.proto at 230:1
 */
export const CatalogModifierListSelectionType = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.CatalogModifierListSelectionType').values;
/**
 * @desc Indicates how a CatalogPricingRule can be combined with other pricing rules.
 *
 * SOURCE AggregationStrategy @ squareup/connect/v2/catalog/resources/enums.proto at 247:1
 */
export const AggregationStrategy = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.AggregationStrategy').values;
/**
 * --
 * @desc Possible types of CatalogObjects returned from the catalog, each
 * containing type-specific properties in the `*_data` field corresponding to the specified object type.
 * --
 *
 * SOURCE CatalogObjectType @ squareup/connect/v2/catalog/resources/enums.proto at 271:1
 */
export const CatalogObjectType = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.CatalogObjectType').values;
/**
 * --
 * @desc Indicates which products matched by a CatalogPricingRule
 * will be excluded if the pricing rule uses an exclude set.
 * --
 *
 * SOURCE ExcludeStrategy @ squareup/connect/v2/catalog/resources/enums.proto at 608:1
 */
export const ExcludeStrategy = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.ExcludeStrategy').values;
/**
 * --
 * @desc Indicates if a PricingRule may be automatically applied, or if some other conditions must be met
 * --
 *
 * SOURCE CatalogPricingRuleApplicationMode @ squareup/connect/v2/catalog/resources/enums.proto at 635:1
 */
export const CatalogPricingRuleApplicationMode = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.CatalogPricingRuleApplicationMode').values;
/**
 * --
 * @desc Determines the scope at which the discounts created by the pricing rule
 * should be applied (i.e.- whole purchase or line item)
 * --
 *
 * SOURCE DiscountTargetScope @ squareup/connect/v2/catalog/resources/enums.proto at 658:1
 */
export const DiscountTargetScope = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.DiscountTargetScope').values;
/**
 * --
 * @desc Determines the scope at which the service charges created by the pricing rule
 * should be applied (i.e.- whole purchase or line item).
 * --
 *
 * SOURCE ServiceChargeTargetScope @ squareup/connect/v2/catalog/resources/enums.proto at 678:1
 */
export const ServiceChargeTargetScope = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.ServiceChargeTargetScope').values;
/**
 * --
 * @desc Determines the type of a specific Quick Amount.
 * --
 *
 * SOURCE CatalogQuickAmountType @ squareup/connect/v2/catalog/resources/enums.proto at 697:1
 */
export const CatalogQuickAmountType = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.CatalogQuickAmountType').values;
/**
 * --
 * @desc Determines a seller's option on Quick Amounts feature.
 * --
 *
 * SOURCE CatalogQuickAmountsSettingsOption @ squareup/connect/v2/catalog/resources/enums.proto at 718:1
 */
export const CatalogQuickAmountsSettingsOption = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.CatalogQuickAmountsSettingsOption').values;
/**
 * --
 * @desc Determines item visibility in Ecom (Online Store) and Online Checkout.
 * --
 *
 * SOURCE EcomVisibility @ squareup/connect/v2/catalog/resources/enums.proto at 744:1
 */
export const EcomVisibility = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.EcomVisibility').values;
/**
 * --
 * @desc Defines the values for the `archived_state` query expression
 * used in [SearchCatalogItems](api-endpoint:Catalog-SearchCatalogItems)
 * to return the archived, not archived or either type of catalog items.
 * --
 *
 * SOURCE ArchivedState @ squareup/connect/v2/catalog/resources/enums.proto at 768:1
 */
export const ArchivedState = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.ArchivedState').values;
/**
 * --
 * @desc Determines service charge type
 * --
 *
 * SOURCE CatalogServiceChargeType @ squareup/connect/v2/catalog/resources/enums.proto at 784:1
 */
export const CatalogServiceChargeType = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.CatalogServiceChargeType').values;
/**
 * --
 * @desc Determines service charge calculation phase
 * --
 *
 * SOURCE CatalogServiceChargeCalculationPhase @ squareup/connect/v2/catalog/resources/enums.proto at 802:1
 */
export const CatalogServiceChargeCalculationPhase = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.CatalogServiceChargeCalculationPhase').values;
/**
 * --
 * @desc Determines service charge type
 * --
 *
 * SOURCE CatalogServiceChargeAutoEnableType @ squareup/connect/v2/catalog/resources/enums.proto at 827:1
 */
export const CatalogServiceChargeAutoEnableType = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.CatalogServiceChargeAutoEnableType').values;
/**
 * --
 * @desc Determines service charge calculation type
 * --
 *
 * SOURCE CatalogServiceChargeCalculationType @ squareup/connect/v2/catalog/resources/enums.proto at 843:1
 */
export const CatalogServiceChargeCalculationType = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.CatalogServiceChargeCalculationType').values;
/**
 * --
 * @desc Determines service charge treatment type
 * --
 *
 * SOURCE CatalogServiceChargeTreatmentType @ squareup/connect/v2/catalog/resources/enums.proto at 859:1
 */
export const CatalogServiceChargeTreatmentType = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.CatalogServiceChargeTreatmentType').values;
/**
 * --
 * @desc Determines the billing cadence of a [Subscription](entity:Subscription)
 * --
 *
 * SOURCE SubscriptionCadence @ squareup/connect/v2/catalog/resources/enums.proto at 874:1
 */
export const SubscriptionCadence = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.SubscriptionCadence').values;
/**
 * --
 * @desc Determines the pricing of a [Subscription](entity:Subscription)
 * --
 *
 * SOURCE SubscriptionPricingType @ squareup/connect/v2/catalog/resources/enums.proto at 922:1
 */
export const SubscriptionPricingType = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.SubscriptionPricingType').values;
/**
 * --
 * @desc Determines the type of checkout link and affects legal copy on checkout page.
 * --
 *
 * SOURCE CheckoutLinkType @ squareup/connect/v2/catalog/resources/enums.proto at 938:1
 */
export const CheckoutLinkType = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.CheckoutLinkType').values;
/**
 * --
 * @desc Object types to inline under their respective parent object in certain connect v2 responses
 * --
 *
 * SOURCE InlineTypes @ squareup/connect/v2/catalog/resources/enums.proto at 963:1
 */
export const InlineTypes = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.InlineTypes').values;
/**
 * --
 * @desc Location types of an event
 * --
 *
 * SOURCE EventLocationType @ squareup/connect/v2/catalog/resources/enums.proto at 990:1
 */
export const EventLocationType = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.EventLocationType').values;
/**
 * --
 * @desc Supported nullable attributes that can be used in a query expression to
 * return items or item variations when a nullable attribute value on the items
 * or item variations matches the associated query expression or when the nullable
 * attribute is not assigned to the items or item variations.
 * --
 *
 * SOURCE NullableField @ squareup/connect/v2/catalog/resources/enums.proto at 1006:1
 */
export const NullableField = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.NullableField').values;
/**
 * --
 * @desc Defines supported stock levels of the item inventory.
 * --
 *
 * SOURCE StockLevel @ squareup/connect/v2/catalog/resources/enums.proto at 1016:1
 */
export const StockLevel = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.StockLevel').values;
/**
 * --
 * @desc Indicates what Square Online fulfillment types the service charge should apply to. Only valid for internal
 * usage by Square Online.
 * --
 *
 * SOURCE CatalogServiceChargeEcomFulfillmentType @ squareup/connect/v2/catalog/resources/enums.proto at 1029:1
 */
export const CatalogServiceChargeEcomFulfillmentType = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.CatalogServiceChargeEcomFulfillmentType').values;
/**
 * --
 * @desc Indicates what Order source the pricing rule should apply to.
 * --
 *
 * SOURCE CatalogPricingSource @ squareup/connect/v2/catalog/resources/enums.proto at 1041:1
 */
export const CatalogPricingSource = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.CatalogPricingSource').values;
/**
 * --
 * @desc Indicates what payment type the pricing rule should apply to.
 * --
 *
 * SOURCE PricingRulePaymentType @ squareup/connect/v2/catalog/resources/enums.proto at 1051:1
 */
export const PricingRulePaymentType = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.PricingRulePaymentType').values;
/**
 * --
 * @desc Enum used by [CatalogMenu](entity:CatalogMenu), [CatalogMenuGroup](entity:CatalogMenuGroup), and [CatalogTag](entity:CatalogTag).
 * --
 *
 * SOURCE CatalogProductName @ squareup/connect/v2/catalog/resources/enums.proto at 1063:1
 */
export const CatalogProductName = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.CatalogProductName').values;
/**
 * --
 * @desc Enum used by [CatalogPlaceholder](entity:CatalogPlaceholder).
 * --
 *
 * SOURCE CatalogPlaceholderType @ squareup/connect/v2/catalog/resources/enums.proto at 1075:1
 */
export const CatalogPlaceholderType = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.CatalogPlaceholderType').values;
/**
 * --
 * @desc Enum used by [CatalogPage](entity:CatalogPage) and [CatalogConfiguration](entity:CatalogConfiguration).
 * --
 *
 * SOURCE CatalogPageLayout @ squareup/connect/v2/catalog/resources/enums.proto at 1136:1
 */
export const CatalogPageLayout = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.CatalogPageLayout').values;
/**
 * --
 * @desc Specifies the device form factor for which a menu is designed.
 * --
 *
 * SOURCE CatalogDeviceFormFactor @ squareup/connect/v2/catalog/resources/enums.proto at 1155:1
 */
export const CatalogDeviceFormFactor = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.CatalogDeviceFormFactor').values;
/**
 * --
 * @desc Enum used by [CatalogTag](entity:CatalogTag).
 * --
 *
 * SOURCE CatalogTagType @ squareup/connect/v2/catalog/resources/enums.proto at 1170:1
 */
export const CatalogTagType = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.CatalogTagType').values;
/**
 * --
 * @desc Unit of weight used to measure a quantity.
 * --
 *
 * SOURCE CatalogItemVariationWeightUnit @ squareup/connect/v2/catalog/resources/enums.proto at 1180:1
 */
export const CatalogItemVariationWeightUnit = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.CatalogItemVariationWeightUnit').values;
/**
 * --
 * @desc The product set will match the specified line item types.
 * --
 *
 * SOURCE CatalogProductSetLineItemType @ squareup/connect/v2/catalog/resources/enums.proto at 1199:1
 */
export const CatalogProductSetLineItemType = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.CatalogProductSetLineItemType').values;
/**
 * @desc possible type of a composition
 *
 * SOURCE CompositionType @ squareup/connect/v2/catalog/resources/enums.proto at 1206:1
 */
export const CompositionType = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.CompositionType').values;
/**
 * @desc type of void reason used by appointments for various void scenarios
 *
 * SOURCE CatalogVoidReasonAppointmentsType @ squareup/connect/v2/catalog/resources/enums.proto at 1219:1
 */
export const CatalogVoidReasonAppointmentsType = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.CatalogVoidReasonAppointmentsType').values;
/**
 * SOURCE CatalogTicketGroupNamingMethod @ squareup/connect/v2/catalog/resources/enums.proto at 1229:1
 */
export const CatalogTicketGroupNamingMethod = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.CatalogTicketGroupNamingMethod').values;
/**
 * SOURCE CatalogTicketGroupPrefixTableNames @ squareup/connect/v2/catalog/resources/enums.proto at 1238:1
 */
export const CatalogTicketGroupPrefixTableNames = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.CatalogTicketGroupPrefixTableNames').values;
/**
 * SOURCE CatalogFloorPlanTileShape @ squareup/connect/v2/catalog/resources/enums.proto at 1246:1
 */
export const CatalogFloorPlanTileShape = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.CatalogFloorPlanTileShape').values;
/**
 * @desc Defines the type of `CatalogModifierList`.
 *
 * SOURCE CatalogModifierListModifierType @ squareup/connect/v2/catalog/resources/enums.proto at 1257:1
 */
export const CatalogModifierListModifierType = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.CatalogModifierListModifierType').values;
/**
 * --
 * @desc Basis for cost of materials required to perform a service
 * --
 *
 * SOURCE ServiceCostType @ squareup/connect/v2/catalog/resources/enums.proto at 1271:1
 */
export const ServiceCostType = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.ServiceCostType').values;
/**
 * @desc Supported values for the sellable filter
 *
 * SOURCE SellableValue @ squareup/connect/v2/catalog/resources/enums.proto at 1283:1
 */
export const SellableValue = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.SellableValue').values;
/**
 * @desc Supported values for the stockable filter
 *
 * SOURCE StockableValue @ squareup/connect/v2/catalog/resources/enums.proto at 1295:1
 */
export const StockableValue = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.StockableValue').values;
/**
 * --
 * @desc Item level overrides for bool attributes
 * --
 *
 * SOURCE CatalogModifierToggleOverrideType @ squareup/connect/v2/catalog/resources/enums.proto at 1309:1
 */
export const CatalogModifierToggleOverrideType = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.CatalogModifierToggleOverrideType').values;
/**
 * --
 * @desc Application Type of CatalogTaxExemption
 * --
 *
 * SOURCE TaxExemptionActionType @ squareup/connect/v2/catalog/resources/enums.proto at 1326:1
 */
export const TaxExemptionActionType = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.TaxExemptionActionType').values;
/**
 * --
 * @desc The program types that a catalog object can be eligible for
 * --
 *
 * SOURCE CatalogProgramType @ squareup/connect/v2/catalog/resources/enums.proto at 1383:1
 */
export const CatalogProgramType = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.CatalogProgramType').values;
/**
 * --
 * @desc Eligibility status for a program
 * --
 *
 * SOURCE CatalogProgramEligibilityStatus @ squareup/connect/v2/catalog/resources/enums.proto at 1399:1
 */
export const CatalogProgramEligibilityStatus = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.CatalogProgramEligibilityStatus').values;
/**
 * --
 * @desc Fields for which to ignore defaults when creating an item
 * --
 *
 * SOURCE IgnoreItemDefaultsField @ squareup/connect/v2/catalog/resources/enums.proto at 1415:1
 */
export const IgnoreItemDefaultsField = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.IgnoreItemDefaultsField').values;
/**
 * --
 * @desc Include types to fetch and return corresponding objects with the response
 * --
 *
 * SOURCE IncludeType @ squareup/connect/v2/catalog/resources/enums.proto at 1428:1
 */
export const IncludeType = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.IncludeType').values;
/**
 * --
 * @desc The color applied to a CatalogModifier for rendering on Kitchen Display System (KDS) chit text,
 * allowing kitchen staff to visually distinguish important modifiers at a glance.
 * --
 *
 * SOURCE CatalogModifierColor @ squareup/connect/v2/catalog/resources/enums.proto at 1445:1
 */
export const CatalogModifierColor = $root.lookupEnum('squareup.connect.v2.merchant_catalog.resources.CatalogModifierColor').values;